import React from "react";
import PropertyMaps from "../../constants/PropertyMaps";
import StyleUtils, { FORMAT_CSS } from "../../utils/StyleUtils";

const { STYLE_PROPS_LINK } = PropertyMaps;

function LinkStyle(props) {
  const { id, linkStyle, theme } = props;

  const css = StyleUtils.getStyleCSS(
    `#${id} a`,
    StyleUtils.getStyle(STYLE_PROPS_LINK, linkStyle, theme, FORMAT_CSS)
  );

  return (
    <style id={id + "-style"} type="text/css" dangerouslySetInnerHTML={{ __html: css }}></style>
  );
}
export default LinkStyle;
